import { persistStateTypes } from '../../../reducers/persistStateReducer';

import { SCREENS, REDUX_ACTIONS, GAME_ID } from '../../data/constants';

const initState = {
  currentScreen: SCREENS.LOADING,
};

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return { currentScreen: payload };

    // return to Progress Screen when gamestate call has been resolved
    case persistStateTypes.REQUESTRESPONSE_GAMESTATE:
    case persistStateTypes.REQUESTERROR_GAMESTATE:
      return { currentScreen: initState.PROGRESS };

    default:
      return state;
  }
};

export default screenReducer;
